enum WorkOSCodes {
  PBWORKOSConnectionsAlreadyExist = "PBWORKOSConnectionsAlreadyExist",
  PBWORKOSExpiredCode = "PBWORKOSExpiredCode"
}

export default WorkOSCodes
